import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
export class MySqlDataSourceEdit extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    schemaLoadingIndex: null,
    showSchemaModal: false,
  };

  async componentDidMount() {
    const { actions } = this.props;
    const { dbUuid, projectId, version } = this.props.match.params;
    await actions.getMySqlExternalDb({ version, projectId, dbUuid });
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
  }

  handleCreateButtonClick = (item, index) => {
    const { match, history } = this.props;
    const { projectId, dbUuid, version } = match.params;
    history.push(`/2.0/data-connector/${version}/v/${projectId}/mysql-datasource/${dbUuid}/create`, {
      collectionIndex: index,
    });
  };

  handleUpdate = (collection, index) => {
    const { match, history } = this.props;
    const { projectId, dbUuid, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/mysql-datasource/${dbUuid}/update/${collection.name}`,
      {
        collectionIndex: index,
      },
    );
  };

  handleSchemaBtn = async (collection, index) => {
    const { match, actions } = this.props;
    const { projectId, dbUuid, version } = match.params;
    const { name } = collection;
    this.setState({ schemaLoadingIndex: index, showSchemaModal: true });
    try {
      await actions.getMySqlTableSchema({ version, projectId, dbUuid, name });
    } catch (error) {
      this.setState({ showSchemaModal: false });
    }
    this.setState({ schemaLoadingIndex: null });
  };

  toggleShowSchemaModal = () => {
    const { showSchemaModal } = this.state;
    this.setState({ showSchemaModal: !showSchemaModal });
  };

  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };

  renderTableSchemaModal = () => {
    const { dataConnector } = this.props;
    const { showSchemaModal } = this.state;
    const { getMySqlTableSchemaPending, mysqlTableSchema } = dataConnector || {};
    const { data } = mysqlTableSchema || {};
    const { tableDDL } = data || {};
    const tableDDLObj = tableDDL && tableDDL.length ? tableDDL[0] : {};
    const { name, createTable } = tableDDLObj || {};

    if (getMySqlTableSchemaPending || !tableDDL) {
      return (
        <Modal
          size="lg"
          isOpen={showSchemaModal}
          toggle={() => this.toggleShowSchemaModal()}
          backdrop="static"
        >
          <ModalHeader toggle={() => this.toggleShowSchemaModal()} className="border-bottom">
            Table Schema (
            {getMySqlTableSchemaPending ? (
              <CustomLoader loading={getMySqlTableSchemaPending} size="5px" color="#303453" />
            ) : (
              name
            )}
            )
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="text-center">
                  <CustomLoader loading={getMySqlTableSchemaPending} size="20px" color="#303453" />
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      );
    } else {
      return (
        <Modal
          size="lg"
          isOpen={showSchemaModal}
          toggle={() => this.toggleShowSchemaModal()}
          backdrop="static"
        >
          <ModalHeader toggle={() => this.toggleShowSchemaModal()} className="border-bottom">
            Table Schema ({name})
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <pre>{createTable}</pre>
              </div>
            </div>
          </ModalBody>
        </Modal>
      );
    }
  };

  renderDataConnectorTableList = () => {
    const { dataConnector } = this.props;
    const {
      mysqlStoredData,
      getMySqlExternalDbPending,
      collectionListExternaldbsPending,
      collectionList,
    } = dataConnector || '';
    const { completeData, name } = mysqlStoredData || {};
    const { tables } = completeData || {};
    if (getMySqlExternalDbPending || collectionListExternaldbsPending || !tables) {
      return (
        <div className="text-center">
          <CustomLoader
            loading={collectionListExternaldbsPending || getMySqlExternalDbPending}
            size="20px"
            color="#303453"
          />
        </div>
      );
    } else {
      return (
        <ParentContentCard
          title={` ${name}'s Collections via MySQL (${tables.length})`}
          icon={'collection'}
        >
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-sm table-word-break connector-list">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>No. of Fields</th>
                  <th>Created at</th>
                  <th>Updated at</th>
                  <th className="w-15">Action</th>
                </tr>
              </thead>
              {this.renderCollectionTableBody(tables, collectionList)}
            </table>
          </div>
        </ParentContentCard>
      );
    }
  };

  renderCollectionTableBody(tables, collectionList) {
    return (
      <tbody>
        {tables &&
          tables.map((item, index) => {
            return this.renderCollectionTableBodyRow(collectionList, item, index);
          })}
      </tbody>
    );
  }

  renderCollectionTableBodyRow(collectionList, item, index) {
    const { isExistingCollection } = item;
    const collectionNames = new Set();
    collectionNames.add(item.name);
    if (isExistingCollection) {
      collectionNames.add(item.mappedCollectionName);
    }
    const matchingObject =
      collectionList && collectionList.find((obj) => collectionNames.has(obj.orgCollectionName));
    const { schemaLoadingIndex } = this.state;
    return (
      <tr className="text-left td-align-middle" key={item.name + index}>
        <td>
          {matchingObject ? (
            <>
              {item.name} <i className={'wb webconnect-check-circle text-success'}></i>
            </>
          ) : (
            <>{item.name}</>
          )}
        </td>
        <td>{Object.keys(item.fields).length}</td>
        <td>
          {matchingObject && matchingObject.createdAt
            ? this.formatDate(new Date(matchingObject.createdAt))
            : ''}
        </td>
        <td>
          {matchingObject && matchingObject.updatedAt
            ? this.formatDate(new Date(matchingObject.updatedAt))
            : ''}
        </td>
        <td className="text-right">
          <button
            className="btn btn-schema btn-theme-green"
            onClick={() => {
              this.handleSchemaBtn(item, index);
            }}
            disabled={schemaLoadingIndex === index}
          >
            {schemaLoadingIndex === index ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <i className="wb webconnect-eye"></i>
            )}
            {' Schema'}
          </button>
          {matchingObject ? (
            <button
              className="btn btn-theme-submit btn-md"
              onClick={() => {
                this.handleUpdate(item, index);
              }}
            >
              <i className="wb webconnect-save-regular"></i>
              {' Update'}
            </button>
          ) : (
            <button
              className="btn btn-create btn-primary"
              onClick={() => {
                this.handleCreateButtonClick(item, index);
              }}
            >
              <i className="wb webconnect-plus"></i>
              {' Create'}
            </button>
          )}
        </td>
      </tr>
    );
  }

  render() {
    const { showSchemaModal } = this.state;
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    return (
      <>
        <CommonPageComponent>{this.renderDataConnectorTableList()}</CommonPageComponent>;
        {showSchemaModal && this.renderTableSchemaModal()}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MySqlDataSourceEdit);
